module.exports = __webpack_public_path__ + "img/img-ahorra.b795362a.png";